import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CheckCircle2 } from 'lucide-react';
export function QuoteCTA() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-284">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="bg-navy rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-286">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1556761175-5973dc0f32d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80')] opacity-10 mix-blend-overlay object-cover pointer-events-none" data-id="element-287"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/95 to-navy/80 pointer-events-none" data-id="element-288"></div>

          <div className="relative z-10 grid lg:grid-cols-2 gap-12 p-8 md:p-16 items-center" data-id="element-289">
            {/* Left side: Copy */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-290">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-291">
                Ready to find your perfect plan?
              </h2>
              <p className="text-lg text-slate-300 mb-8" data-id="element-292">
                Get a free, personalized quote in minutes. Our licensed agents
                are standing by to help you compare options and save.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-293">
                <li className="flex items-center gap-3 text-white" data-id="element-294">
                  <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0" data-id="element-295" />
                  <span data-id="element-296">100% Free Consultation</span>
                </li>
                <li className="flex items-center gap-3 text-white" data-id="element-297">
                  <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0" data-id="element-298" />
                  <span data-id="element-299">No Obligation to Enroll</span>
                </li>
                <li className="flex items-center gap-3 text-white" data-id="element-300">
                  <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0" data-id="element-301" />
                  <span data-id="element-302">Licensed Local Experts</span>
                </li>
              </ul>
            </motion.div>

            {/* Right side: Form */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-303">
              <h3 className="text-xl font-bold text-navy mb-6 flex items-center gap-2" data-id="element-304">
                <Shield className="w-5 h-5 text-accent" data-id="element-305" />
                Request Your Quote
              </h3>

              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-306">
                <div data-id="element-307">
                  <label htmlFor="name" className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-308">
                    Full Name
                  </label>
                  <input type="text" id="name" placeholder="John Doe" className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent font-medium" data-id="element-309" />
                </div>

                <div data-id="element-310">
                  <label htmlFor="phone" className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-311">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" placeholder="(555) 000-0000" className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent font-medium" data-id="element-312" />
                </div>

                <div data-id="element-313">
                  <label htmlFor="interest" className="block text-sm font-semibold text-slate-700 mb-1.5" data-id="element-314">
                    Coverage Interest
                  </label>
                  <select id="interest" className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent appearance-none font-medium" defaultValue="" data-id="element-315">
                    <option value="" disabled data-id="element-316">
                      Select coverage type...
                    </option>
                    <option value="medicare" data-id="element-317">Medicare</option>
                    <option value="health" data-id="element-318">Health Insurance</option>
                    <option value="life" data-id="element-319">Life Insurance</option>
                    <option value="other" data-id="element-320">Other / Not Sure</option>
                  </select>
                </div>

                <button className="w-full bg-accent hover:bg-accent-hover text-navy-dark font-bold text-lg py-3.5 rounded-xl transition-colors mt-4 shadow-sm" data-id="element-321">
                  Get My Quote
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}